/**
 * NotifGate - first-run prompt that asks the OS for notification permission
 * and points at the system dialog. Closes when the user returns to the app
 * (visibility becomes visible again after dismissing the OS sheet).
 */
import { useRef, useEffect } from 'preact/hooks';
import { requestNotificationPermission } from '../bridge/puerInterface.js';
import { setItem } from '../lib/storage.js';
import { Keys } from '../lib/adScheduler.js';

export function NotifGate({ onClose }) {
  const requested = useRef(false);

  useEffect(() => {
    if (requested.current) return;
    requested.current = true;

    requestNotificationPermission();
    setItem(Keys.notifPermRequested, '1');

    const onVisibility = () => {
      if (document.visibilityState === 'visible') onClose();
    };
    document.addEventListener('visibilitychange', onVisibility);
    return () => document.removeEventListener('visibilitychange', onVisibility);
  }, []);

  return (
    <div class="gate">
      <div class="gate__content">
        <div class="gate__text">Allow notifications below</div>
        <div class="gate__arrow" aria-hidden="true">
          ↓
        </div>
      </div>
    </div>
  );
}
